export const addCommasToNumber = (num: number) =>
  String(num).replace(/(.)(?=(\d{3})+$)/g, '$1,')
